import { DenialCheckAction } from 'models/DenialCheckAction';
import { DiscoverPortalActivityAction } from 'models/DiscoverPortalActivityAction';
import { DisposePortalActivityAction } from 'models/DisposePortalActivityAction';
import { SexOffenderCheckAction } from 'models/SexOffenderCheckAction';
import { WorkflowAction, WorkflowActionOptions } from 'models/WorkflowAction';

export default class WorkflowActionModelFactory {
  private static defaultClass = WorkflowAction;

  // Keyed by the demodulized action kind (`WorkflowActionDefinition::DenialCheck` -> `DenialCheck`).
  // A kind absent here uses the base WorkflowAction — add an entry only when a kind needs bespoke
  // model behavior (e.g. DenialCheck's result-derived presentation).
  private static mapping: Record<string, new (options: Partial<WorkflowActionOptions>) => WorkflowAction> = {
    DenialCheck: DenialCheckAction,
    DiscoverPortalActivity: DiscoverPortalActivityAction,
    DisposePortalActivity: DisposePortalActivityAction,
    SexOffenderCheck: SexOffenderCheckAction,
  };

  /**
   * Returns an instance of the appropriate class based on the options provided.
   * @see {@link https://www.typescriptlang.org/docs/handbook/2/functions.html#function-overloads Function Overloads}
   */
  static get(options: Partial<WorkflowActionOptions>): WorkflowAction {
    const kind = (options.actionType ?? '').split('::').pop() ?? '';
    const klass = this.mapping[kind] ?? this.defaultClass;
    return new klass(options);
  }
}
